<template>
  <div v-if="isLoaded">
    <div
      class="content-body"
      v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header">
              <v-tour
                name="OCsTour"
                :steps="steps"
                :callbacks="callbacksTour"
              ></v-tour>
              <h4 class="card-title step-inicio">Ordens de Coleta</h4>
              <a class="heading-elements-toggle"
                ><i
                  class="fa fa-ellipsis-v font-medium-3"
                  @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
                ></i
              ></a>
              <div
                class="heading-elements"
                v-bind:class="{
                  visible: getSubMenuShowHideFw(),
                  '': !getSubMenuShowHideFw(),
                }"
              >
                <ul class="list-inline mb-0">
                  <li>
                    <a
                      @click="onAprovarClick()"
                      v-b-tooltip
                      title="Aprovar Ordens de Coleta"
                      v-if="getPermissionFw('ordemcoleta.aprovaroc')"
                      ><i class="ft-check step-aprovar"></i
                    ></a>
                  </li>
                  <li>
                    <a
                      @click="onCreateOc()"
                      v-b-tooltip
                      title="Cancelar Ordens de Coleta"
                      v-if="getPermissionFw('gerarordemcoleta.store')"
                      ><i class="ft-x step-cancelar"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="card-content">
              <div class="table-responsive" style="min-height: 72vh;">
                <div v-if="vuetableFilterRow" class="step-filtrar">
                  <vuetable-filterbar> </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div class="loadingData" v-if="loadingData">
                    <div class="loadingDataSpinner">
                      <spinner
                        v-if="loadingData"
                        text-fg-color="#ffffff"
                        message="Carregando..."
                      ></spinner>
                    </div>
                  </div>
                  <div>
                    <a
                      @click="searchAll()"
                      v-b-tooltip
                      title="Selecionar todas as páginas"
                      v-if="getPermissionFw('ordemcoleta.index')"
                      ><i
                        class="fa fa-check-square-o fa-lg"
                        style="margin: 0px 0px 5px 4px"
                      ></i
                    ></a>
                  </div>
                  <vuetable
                    ref="vuetable"
                    api-url="/api/ordemcoleta"
                    :fields="fields"
                    :css="css"
                    :append-params="moreParams"
                    :row-class="onRowClass"
                    track-by="ordcolId"
                    pagination-path="meta"
                    @vuetable:pagination-data="onPaginationData"
                    @vuetable:cell-clicked="onDetail"
                    @vuetable:loaded="onLoaded"
                    detail-row-component="ordem-coleta-detalhes"
                    :load-on-start="false"
                    :no-data-template="noDataText"
                  >
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                          @click="onInserirInfos(props.rowData)"
                          v-b-tooltip
                          title="Inserir Transportadora"
                          ><i class="fa fa-car"></i
                        ></a>
                        <a
                          @click="onAprovarOc(props.rowData)"
                          v-b-tooltip
                          title="Aprovar"
                          ><i class="fa fa-check"></i
                        ></a>
                        <a
                          @click="onCancelarOc(props.rowData)"
                          v-b-tooltip
                          title="Cancelar"
                          ><i class="fa fa-times"></i
                        ></a>
                        <a
                          @click="onImprimirOc(props.rowData)"
                          v-b-tooltip
                          title="Imprimir"
                          ><i class="fa fa-print"></i
                        ></a>
                        <a
                          @click="onReceberOc(props.rowData)"
                          v-b-tooltip
                          title="Receber"
                          ><i class="fa fa-truck"></i
                        ></a>
                        <a
                          @click="onEscanearOc(props.rowData)"
                          v-b-tooltip
                          title="Escanear Volumes"
                          ><i class="fa fa-barcode"></i
                        ></a>
                        <a
                          @click="onDetail(props.rowData)"
                          v-b-tooltip
                          title="Ver detalhes"
                          ><i class="fa fa-plus"></i
                        ></a>
                      </div>
                    </template>
                  </vuetable>
                </div>
                <div class="col-md-12">
                  <div class="pull-left pagination-detail">
                    <vuetable-pagination-info
                      ref="paginationInfo"
                      :css="css.pagination"
                      info-class="pull-left"
                    ></vuetable-pagination-info>
                  </div>
                  <div class="pull-right m-a-0">
                    <vuetable-pagination
                      ref="pagination"
                      :css="css.pagination"
                      @vuetable-pagination:change-page="onChangePage"
                    ></vuetable-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { rowClassByDueDate } from "../utils";
import accounting from "accounting";
import moment from "moment";
import OrdemColetaDetalhes from "./OrdemColetaDetalhes";
import OrdemColetaFilterBar from "./OrdemColetaFilterBar";
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";

Vue.component("ordem-coleta-detalhes", OrdemColetaDetalhes);

export default {
  name: "OCsTour",
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    "vuetable-filterbar": OrdemColetaFilterBar,
  },
  data() {
    return {
      callbacksTour: {
        onNextStep: this.tourNextStepCallback,
        onStop: this.tourStop,
      },
      steps: [
        {
          target: ".step-inicio",
          content: `Para acessar uma ordem de coleta é muito fácil. <strong>Veja nossas dicas básicas</strong> para utilizar a tela e as funcionalidades disponíveis`,
        },
        {
          target: ".step-aprovar",
          content:
            "Para aprovar uma ordem de coleta, você deve selecionar as ordens e clicar no botão ao lado.",
          params: {
            placement: "left",
          },
        },
        {
          target: ".step-cancelar",
          content:
            "Para cancelar uma Ordem de Coleta, você deve selecionar as ordens e clicar no botão ao lado.",
          params: {
            placement: "left",
          },
        },
        {
          target: ".step-filtrar",
          content:
            "Para filtrar uma ordem em específico, você pode utilizar de diversos filtros.",
          params: {
            placement: "top",
          },
        },
      ],
      date_attributes: [{ key: "today", highlight: true, dates: new Date() }],
      firstLoad: true,
      loading: false,
      loadingData: false,
      filter_data_store: {},
      filtrosForm: new Form({
        num_oc: "",
        lote: "",
        status: "",
        transportadora: "",
        motorista_pri: "",
        motorista_sec: "",
        placa_pri: "",
        placa_sec: "",
        placa_ter: "",
        dt_ini: "",
        dt_fim: "",
        dt_aprovacao_ini: "",
        dt_aprovacao_fim: "",
        dt_cancelamento_ini: "",
        dt_cancelamento_fim: "",
      }),
      fields: [
        {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "ordcolId",
          title: "Número",
        },
        {
          name: "dtOc",
          title: "Data Criação",
          callback: this.formatDateSubmit,
        },
        {
          name: "dtAprovacaoOc",
          title: "Data Aprovação",
          callback: this.formatDateSubmit,
        },
        {
          name: "dtRecebimentoOc",
          title: "Data Recebimento",
          callback: this.formatDateSubmit,
        },
        {
          name: "doca", // TODO : Puxar do campo de área, para saber qual doca foi recebido
          title: "Doca Recebimento",
        },
        {
          name: "pessoa.pessoaJuridica.razao_social",
          title: "Transportadora",
        },
        {
          name: "veiculoMotorista.pessoaMotorista.PessoaFisica.nome",
          title: "Motorista",
        },
        {
          name: "meioTransportePrimario.veiculo.placa",
          title: "Placa",
        },
        {
          name: "meioTransportePrimario.veiculo.paramTipoVeiculo.descr",
          title: "Tipo Veículo",
        },
        {
          name: "vlr_total_nfs",
          title: "Valor",
          callback: this.formatNumber,
        },
        {
          name: "peso_bruto_total",
          title: "Peso Bruto",
          callback: this.formatNumber,
        },
        {
          name: "peso_liquido_total",
          title: "Peso Líquido",
          callback: this.formatNumber,
        },
        {
          name: "qtd_volume",
          title: "Volumes",
        },
        {
          name: "qtd_nfs",
          title: "Notas",
        },
        {
          name: "status",
          title: "Status",
          callback: this.formatStatus,
        },
        {
          name: "__slot:actions",
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        tableClass: "table",
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
        detailRowClass: "vuetable-detail-row",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (eventData) => this.onFilterReset(eventData));
  },
  methods: {
    throwErrorNotSelected() {
      return this.$Simplert.open({
        title: "Atenção",
        message: "Selecione pelo menos uma ordem de coleta!",
        customCloseBtnText: "Fechar",
        type: "error",
      });
    },
    searchAll(data_filter, tipo) {
      if (tipo == 2) {
        this.filter_data_store = data_filter;
      }
      if (tipo != 2) {
        this.loadingData = true;
        if (this.$refs.vuetable.selectedTo.length == 0) {
          this.filtrosForm.num_oc = this.filter_data_store.num_oc;
          this.filtrosForm.lote = this.filter_data_store.lote;
          this.filtrosForm.status = this.filter_data_store.status;
          this.filtrosForm.transportadora =
            this.filter_data_store.transportadora;
          this.filtrosForm.motorista_pri = this.filter_data_store.motorista_pri;
          this.filtrosForm.motorista_sec = this.filter_data_store.motorista_sec;
          this.filtrosForm.placa_pri = this.filter_data_store.placa_pri;
          this.filtrosForm.placa_sec = this.filter_data_store.placa_sec;
          this.filtrosForm.placa_ter = this.filter_data_store.placa_ter;
          this.filtrosForm.dt_ini = this.filter_data_store.dt_ini;
          this.filtrosForm.dt_fim = this.filter_data_store.dt_fim;
          this.filtrosForm.dt_aprovacao_ini =
            this.filter_data_store.dt_aprovacao_ini;
          this.filtrosForm.dt_aprovacao_fim =
            this.filter_data_store.dt_aprovacao_fim;
          this.filtrosForm.dt_cancelamento_ini =
            this.filter_data_store.dt_cancelamento_ini;
          this.filtrosForm.dt_cancelamento_fim =
            this.filter_data_store.dt_cancelamento_fim;
          this.filtrosForm
            .post("/api/ordemcoleta/all")
            .then((response) => {
              new ReturnApi(response, this, true, false, false);
              response.forEach((obj) => {
                this.$refs.vuetable.selectedTo.push(parseFloat(obj));
              });
              this.loadingData = false;
            })
            .catch((errors) => {
              new ReturnApi(errors, this);
              this.loadingData = false;
            });
        } else {
          this.$refs.vuetable.selectedTo = [];
          this.loadingData = false;
        }
      }
    },
    startTour() {
      this.$tours["OCsTour"].start();
    },
    tourNextStepCallback(currentStep) {
      // if(currentStep) Abrir o menu com opções
    },
    tourStop() {},
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(data_filter) {
      this.firstLoad = false;
      this.loadingData = true;
      this.moreParams = {
        num_oc: data_filter.num_oc,
        lote: data_filter.lote,
        status: data_filter.status,
        transportadora: data_filter.transportadora,
        motorista: data_filter.motorista,
        placa: data_filter.placa,
        dt_ini: data_filter.dt_ini,
        dt_fim: data_filter.dt_fim,
        dt_aprovacao_ini: data_filter.dt_aprovacao_ini,
        dt_aprovacao_fim: data_filter.dt_aprovacao_fim,
        dt_cancelamento_ini: data_filter.dt_cancelamento_ini,
        dt_cancelamento_fim: data_filter.dt_cancelamento_fim,
      };
      if (JSON.stringify(this.moreParams) != "{}") {
        this.searchAll(this.moreParams, 2);
      }
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterReset(data_filter) {
      this.$refs.vuetable.selectedTo = [];
      this.onFilterSet(data_filter);
    },
    onLoaded() {
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.ordcolId);
    },
    onInserirInfos(data) {
      alert("inserindo infos...", data);
    },
    onAprovarOc(data) {
      alert("aprovando oc...", data);
    },
    onImprimirOc(data) {
      alert("imprimindo oc...", data);
    },
    onCancelarOc(data) {
      alert("cancelando oc...", data);
    },
    onReceberOc(data) {
      alert("recebendo oc...", data);
    },
    onEscanearOc(data) {
      alert("escaneando oc...", data);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2);
    },
    formatDate(value, fmt = "D MMM YYYY") {
      return value == null ? "" : moment(value, "YYYY-MM-DD").format(fmt);
    },
    formatDateSubmit(value, fmt = "DD/MM/YYYY HH:mm:ss") {
      return value == null || value == ""
        ? ""
        : moment(value, "YYYY/MM/DD HH:mm:ss").format(fmt);
    },
    formatStatus(value) {
      const status = {
        1: "Gerado",
        2: "Pendente",
        3: "Aprovado",
        4: "Recebido",
        5: "Cancelado",
      };
      return status[value] || value;
    },
    onRowClass(data) {
      const emAtraso = [];
      data.redespachos.forEach((redespacho) => {
        redespacho.notas.forEach((nota) => {
          emAtraso.push(
            rowClassByDueDate(
              nota.dtPrevisao, 
              this.invoiceDueAlert, 
              this.invoiceDueAlertDays));
        });
      });
      // se tiver uma nota com uma classe preenchida (em atraso), retorna a classe
      return emAtraso.every((str) => str === "")
        ? ""
        : emAtraso.find((str) => str !== "");
    },
    onAprovarClick() {
      alert("aprovando oc...");
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.getters.vuetable.filterRow;
      },
    },
    apiVersion: {
      get() {
        return this.$store.getters.api_version;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      },
    },
    noDataText: {
      get() {
        if (this.firstLoad) {
          return "Clique em filtrar para carregar as ordens de coleta.";
        } else {
          return "Nenhum registro encontrado.";
        }
      },
    },
    invoiceDueAlert() {
      return this.$store.getters.unidade_active.aviso_vencimento;
    },
    invoiceDueAlertDays() {
      return this.$store.getters.unidade_active.dias_vencimento;
    },
  },
};
</script>
